import { render, staticRenderFns } from "./CollectionActionCall.vue?vue&type=template&id=5e9f5370&scoped=true&"
import script from "./CollectionActionCall.vue?vue&type=script&lang=ts&"
export * from "./CollectionActionCall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9f5370",
  null
  
)

export default component.exports